/* Zafari (2026-10-15): capa de velocidad.
   1) Mapas de Google diferidos: el iframe recién se crea cuando el bloque entra en pantalla (o al tocarlo) y, dentro de
      una ventana, cuando esa ventana se abre. Antes el embed (unos 460 KB de JS y tiles) bajaba en casi todas las
      páginas: loading="lazy" en un iframe no alcanza, el navegador lo carga a 1.250-2.500 px del borde.
   2) GIFs de la descripción: salen sin src (un SVG vacío del mismo tamaño y la URL real en data-zf-src) y se cargan
      recién cuando entran en pantalla. El CDN de Shopify los sirve completos (WebP de 0,5 a 1,9 MB a Chrome, el GIF
      original a Safari) e ignora ?width= y, para Safari, también ?format=. Los prepara snippets/zf-rte-media.liquid.
   Sin IntersectionObserver todo se carga de una, como antes.
   3) 2026-10-16: si el recuadro trae un mapa fijo (.zf-map-static, OpenStreetMap), el de Google entra con un fundido
      cuando terminó de cargar (data-zf-map-loaded; estilos en zf-global.css). Al apoyar el mouse, el dedo o el foco en
      el botón que abre una ventana con mapa se pide el mapa fijo (si era lazy); el iframe NO se crea con la ventana
      cerrada: probado el 16-10, el embed de Google se dibuja para un tamaño cero y al abrirse se ve roto un segundo. */
(function () {
  'use strict';
  var IO = 'IntersectionObserver' in window;

  /* --- mapas --- */
  function mountMap(box) {
    if (!box || box.hasAttribute('data-zf-map-on')) return;
    box.setAttribute('data-zf-map-on', '');
    var f = document.createElement('iframe');
    f.src = box.getAttribute('data-zf-map-src');
    f.title = box.getAttribute('data-zf-map-title') || 'Mapa';
    // sin loading="lazy": acá ya se decidió cargarlo, y un iframe lazy dentro de una ventana cerrada no bajaría nada
    f.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    if (box.querySelector('.zf-map-static')) {
      f.setAttribute('data-zf-fade', '');
      f.addEventListener('load', function () { box.setAttribute('data-zf-map-loaded', ''); });
    }
    var btn = box.querySelector('.zf-lazy-map__btn');
    if (btn) btn.parentNode.removeChild(btn);
    box.appendChild(f);
  }
  /* precarga por intención: el botón que abre la ventana (aria-controls de Hyper o data-zfc-open de las ventanas de
     confianza) apunta al contenedor; al apoyar el mouse, el dedo o el foco se pide el mapa fijo si todavía era lazy.
     El iframe de Google lo crea el IntersectionObserver apenas la ventana se ve (ver el punto 3 de arriba). */
  function prefetchFor(el) {
    var id = el.getAttribute('aria-controls') || el.getAttribute('data-zfc-open');
    var target = id && document.getElementById(id);
    if (!target) return;
    var stills = target.querySelectorAll('[data-zf-map-src] .zf-map-static');
    for (var i = 0; i < stills.length; i++) {
      if (stills[i].loading === 'lazy') stills[i].loading = 'eager';
    }
  }
  function onIntent(e) {
    var el = e.target && e.target.closest && e.target.closest('[aria-controls], [data-zfc-open]');
    if (el) prefetchFor(el);
  }
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  function watchMap(box) {
    if (box.hasAttribute('data-zf-map-watch')) return;
    box.setAttribute('data-zf-map-watch', '');
    box.addEventListener('click', function () { mountMap(box); });
    // 2026-10-16: data-zf-map-click = Google sólo al tocar (página Contacto), sin IntersectionObserver
    if (box.hasAttribute('data-zf-map-click')) return;
    var dlg = box.closest && box.closest('dialog');
    if (dlg) {
      if (dlg.open) { mountMap(box); return; }
      if (!('MutationObserver' in window)) { mountMap(box); return; }
      new MutationObserver(function (m, obs) {
        if (dlg.open) { mountMap(box); obs.disconnect(); }
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
      return;
    }
    if (!IO) { mountMap(box); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { mountMap(box); io.disconnect(); return; }
      }
    }, { rootMargin: '200px 0px' });
    io.observe(box);
  }

  /* --- GIFs --- */
  function animate(img) {
    var src = img.getAttribute('data-zf-src');
    if (!src) return;
    img.removeAttribute('data-zf-src');
    img.setAttribute('data-zf-anim-on', '');
    img.setAttribute('src', src);
  }
  function watchGif(img) {
    if (img.hasAttribute('data-zf-anim-watch')) return;
    img.setAttribute('data-zf-anim-watch', '');
    if (!IO) { animate(img); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { animate(img); io.disconnect(); return; }
      }
    }, { rootMargin: '100px 0px' });
    io.observe(img);
  }

  /* --- videos de la descripción (2026-10-16: los MP4 que reemplazan a los GIF; snippets/zf-rte-media.liquid les saca
     el src y deja el póster; acá se cargan y arrancan al entrar en pantalla, y se pausan al salir) --- */
  function playVideo(v) {
    var src = v.getAttribute('data-zf-src');
    if (src) { v.removeAttribute('data-zf-src'); v.setAttribute('src', src); v.load(); }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function watchVideo(v) {
    if (v.hasAttribute('data-zf-video-watch')) return;
    v.setAttribute('data-zf-video-watch', '');
    v.muted = true;
    if (!IO) { playVideo(v); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) playVideo(v); else if (!v.paused) v.pause();
      }
    }, { rootMargin: '150px 0px' });
    io.observe(v);
  }

  function scan(root) {
    root = root && root.querySelectorAll ? root : document;
    var maps = root.querySelectorAll('[data-zf-map-src]');
    for (var i = 0; i < maps.length; i++) watchMap(maps[i]);
    var gifs = root.querySelectorAll('img[data-zf-src]');
    for (var j = 0; j < gifs.length; j++) watchGif(gifs[j]);
    var vids = root.querySelectorAll('.rte video[data-zf-src], .rte video[autoplay]');
    for (var k = 0; k < vids.length; k++) watchVideo(vids[k]);
  }
  scan(document);
  // el editor de temas vuelve a renderizar secciones; y las pestañas de la ficha mueven la descripción de lugar
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.zfPerfScan = scan;
})();
